import { computed } from 'vue';
import { featureFlag } from './instance';

export function useFeatureFlag(key: string) {
  return computed(() => featureFlag.isEnabled(key));
}
